import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";
import moment from "moment";

var today = new Date();
today.setHours(today.getHours() - 6);

export const get_gasflow_data = createAsyncThunk("gasflow", async (data) => {
  var formdata = new FormData();
  formdata.append("userid", data.userid);
  formdata.append("branchid", data.id);
  formdata.append("start", moment(today).format("YYYY-MM-DD HH:mm:ss"));
  formdata.append("end", moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));

  const responce = await fetch(baseUrl + "gaasflowlist", {
    method: "POST",
    body: formdata,
  });
  const res = await responce.json();
  // console.log("gasflow", res);
  return res;
});

const gasflowSlice = createSlice({
  name: "gasflow",
  initialState: {
    gasflow_list: [],
    gasflow_loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(get_gasflow_data.pending, (state, action) => {
      state.gasflow_loading = true;
    });
    builder.addCase(get_gasflow_data.rejected, (state, action) => {
      state.gasflow_loading = false;
    });
    builder.addCase(get_gasflow_data.fulfilled, (state, action) => {
      state.gasflow_loading = false;
      const data = action.payload;
      if (data.success) {
        state.gasflow_list = data.list;
      } else {
        state.gasflow_list = [];
      }
    });
  },
});
export default gasflowSlice.reducer;
